import { Injectable } from '@angular/core';
import { ProviderEnum } from '@proxy/subscriptions/provider-enum.enum';
import { RegionEnum } from '@proxy/subscriptions/region-enum.enum';

@Injectable({
  providedIn: 'root'
})
export class RegionProviderMappingService {

  getProvidersForRegion(regionValue: number): ProviderEnum[] {
    switch (regionValue) {
      case RegionEnum.Turkey:
        return [ProviderEnum.Eclit, ProviderEnum.Huawei];
      case RegionEnum.Dubai:
        return [ProviderEnum.AWS, ProviderEnum.Azure];
      case RegionEnum.Jeddah:
        return [ProviderEnum.OracleProd, ProviderEnum.OraclePreProd];
      default:
        return [ProviderEnum.AWS];
    }
  }

  getDefaultProviderForRegion(regionValue: number): ProviderEnum {
    switch (regionValue) {
      case RegionEnum.Turkey:
        return ProviderEnum.Eclit;
      case RegionEnum.Dubai:
        return ProviderEnum.AWS;
      case RegionEnum.Jeddah:
        return ProviderEnum.OracleProd;
      default:
        return ProviderEnum.AWS;
    }
  }

  getProviderOptions(regionValue?: number) {
    if (regionValue === undefined || regionValue === null) {
      return [];
    }

    const enabledProviders = this.getProvidersForRegion(regionValue);
    
    // Return provider options structure similar to existing code
    return Object.values(ProviderEnum)
      .filter(value => typeof value === 'number')
      .map(value => ({
        value: value as ProviderEnum,
        key: ProviderEnum[value as ProviderEnum],
        disabled: !enabledProviders.includes(value as ProviderEnum)
      }));
  }
}